import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { HttpClientModule } from '@angular/common/http'; 
import { environment } from '../../../environments/environment';
import { AuthenticationService } from "../../views/authentication/authentication.service";
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';





@Injectable()
export class AppTreeDiagramService{

  constructor(private http: HttpClient,  private authService: AuthenticationService) {
  }

  getHeaders(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.authService.token);
    return headers;
  }

  getData() : Observable<any>  {
    return this.http.get(environment.HR + '/hr/complete-structure/', { headers: this.getHeaders() })
  }

  whoIs(key : any) : Observable<any> {
    return this.http.get(environment.HR + '/hr/entity/'+ key, { headers: this.getHeaders() })
  }

  getTotalPerson(key: any) : Observable<any>  {
    return this.http.get(environment.API + '/details/total-by-person/'+ key, { headers: this.getHeaders() }).catch(this.errorHandler);
  }

  getCosts(key: any) : Observable<any>  {
    return this.http.get(environment.API + '/details/totals-by-account/'+ key, { headers: this.getHeaders() })
    
  }

  getTotalCorp(key: any) : Observable<any>  {
    return this.http.get(environment.API + '/details/total-corporate-unit/'+ key, { headers: this.getHeaders() })
  }

  changeParent(change: any) : Observable<any>  {
    return this.http.post(environment.HR + '/hr/change-parent/',change,{headers: this.getHeaders()});
  }

  getOrphans() : Observable<any>  {
    return this.http.get(environment.API + '/hr/orphan-resources/' + { headers: this.getHeaders() })
  }

  addResource(resource: any) : Observable<any>  {

    return this.http.post(environment.API + '/hr/add-entity/',resource, { headers: this.getHeaders() })
  }

  changeInfo(resource: any) : Observable<any>  {

    return this.http.post(environment.API + '/hr/edit-entity/',resource, { headers: this.getHeaders() })
  }

  errorHandler(error: HttpErrorResponse)
  {
    return Observable.throw(error.message || "Server Error");
  }

  newcode() : Observable<any>  {

    return this.http.get(environment.HR + '/hr/entities/', { headers: this.getHeaders() })
  }


}




// WEBPACK FOOTER //
// ./src/app/components/app-tree-diagram/app-tree-diagram.service.ts